import Create from "./create/CreateLabel";
import Edit from "./edit/EditLabel";
import Individual from "./individual/Label";
import List from "./list/Labels";

export default { List, Create, Individual, Edit };
